var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[(_vm.email.email === 'pruebas@databot.cl'|| _vm.email.email === 'sergio@databot.cl'
                 || _vm.email.email === 'nicolas@databot.cl')?[_c('div',{staticClass:"container"},[_c('h2',{staticClass:"display-3 mb-3"},[_vm._v("Bienvenido "+_vm._s(_vm.user.name)+" ")])])]:void 0],2)
}
var staticRenderFns = []

export { render, staticRenderFns }